<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { ProjectPlanEditorFormSubmitEventPayload, ProjectPlanEditorViewModel } from "@Quest/Projects/Components/ProjectPlanEditor";


    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class ProjectPlanEditor extends Vue
    {
        get vm(): ProjectPlanEditorViewModel { return this.$props.viewModel as ProjectPlanEditorViewModel; }
        get opened(): boolean { return this.vm?.opened ?? false; }

        get confirmButtonLabel(): string { return this.vm.confirmButtonLabel; }
        get modalTitle(): string { return this.vm.modalTitle; }

        get name(): string { return this.vm.name; }
        set name(val: string) { this.vm.name = val; }

        get granularity(): string { return this.vm.granularity; }
        set granularity(val: string) { this.vm.granularity = val; }

        get denomination(): string { return this.vm.denomination; }
        set denomination(val: string) { this.vm.denomination = val; }

        get duration(): number { return this.vm.duration; }
        set duration(val: number) { this.vm.duration = val; }

        get planningHorizonInYears(): number { return this.vm.planningHorizonInYears; }
        set planningHorizonInYears(val: number) { this.vm.planningHorizonInYears = val; }

        get dueDate(): string | null { return this.vm.dueDate; }
        set dueDate(val: string | null) { this.vm.dueDate = val; }

        onFormSubmit()
        {
            this.$emit('form-submit', new ProjectPlanEditorFormSubmitEventPayload(this.vm.id, this.name, this.duration, this.granularity, this.denomination, this.planningHorizonInYears, this.dueDate));
        }

        close()
        {
            this.vm.close();
        }
    }

</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ modalTitle }}</h5>
                        <button @click="close" type="button" class="close">&times;</button>
                    </div>
                    <div class="modal-body">
                        <form id="project-plan-editor-form" @submit.prevent="onFormSubmit">
                            <div class="form-group">
                                <label>Name:</label>
                                <input type="text" v-model.trim="name" class="form-control" required minlength="2" maxlength="100" />
                            </div>

                            <div class="form-group">
                                <label for="account">Granularity:</label>
                                <select id="account" v-model="granularity" class="form-control">
                                    <option value="Monthly">Monthly</option>
                                    <option value="Quarterly">Quarterly</option>
                                    <option value="Yearly">Yearly</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label for="denomination">Currency denomination:</label>
                                <select id="denomination" v-model="denomination" class="form-control">
                                    <option value="Unit">Unit</option>
                                    <option value="Thousand">Thousand</option>
                                    <option value="Million">Million</option>
                                </select>
                            </div>

                            <div class="form-group">
                                <label>Duration (in months):</label>
                                <input type="number" v-model.number="duration" class="form-control" required min="1" step="1" />
                            </div>

                            <div class="form-group">
                                <label>Planning horizon (in years):</label>
                                <input type="number" v-model.number="planningHorizonInYears" class="form-control" required min="1" />
                            </div>

                            <div class="form-group">
                                <label>Submission due date:</label>
                                <input type="date" class="form-control" v-model="dueDate" />
                            </div>

                        </form>

                    </div>
                    <div class="modal-footer">
                        <button @click="close" type="button" class="btn btn-outline-secondary">Cancel</button>
                        <button type="submit" form="project-plan-editor-form" class="btn btn-primary">{{ confirmButtonLabel }}</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>